import { render, staticRenderFns } from "./CheckboxSelectForm.vue?vue&type=template&id=72902a52"
import script from "./CheckboxSelectForm.vue?vue&type=script&lang=js"
export * from "./CheckboxSelectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports